// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: Roboto-Regular;
  src: url(/assets/fonts/Roboto-Regular/Roboto-Regular.woff);
}
.caption {
  font-size: 13px;
  line-height: 18px;
  font-weight: 300;
  color: #231F20;
  font-style: italic;
  margin-bottom: 60px;
  padding-right: 450px;

}

.responsive {
  width: 72%;
  height: auto;
}

.image {

  z-index: 2;
  bottom: 0;
  position: absolute;
  right: 0;
  text-align: right;
  padding: 0;

}


.mainContent {
  background: linear-gradient(47.69deg, rgba(103, 191, 198, 0.45) 16.16%, rgba(142, 198, 64, 0.45) 83.81%);
  width: 100%;
  height: 100%;
}

.mainContent_2 {
  z-index: 9999;
  background: #F1F2F2;

}

.footer_1 {
  padding-right: 6%;
}

.footer_2 {
  padding-left: 9%;
}

.title {
  margin-top: 116px;
}


.subcontent {
  margin-top: 51px;
  padding-right: 25%;
}

.subcontent_2 {
  margin-top: 27px;
  text-align: left;
}

.quiz {
  margin-top: 69px;

}

.contentQuiz {
  z-index: 5;
}

.content_footer {
  padding-left: 210px;
  padding-top: 92px;
  padding-right: 296px;
  padding-bottom: 92px;
}

.question {
  margin-top: 55px;
  margin-bottom: 147px;
  color: #1E5634;
  font-size: 25px;
  line-height: 137.19%;
  font-family: Roboto-Bold;
  padding-right: 31%;
}


.circle1 {
  background: rgba(142, 198, 64, 0.6);
  height: auto;
  padding-top: 100%;
  width: 100%;
  border-radius: 50%;
  position: absolute;
  bottom: -12%;
  left: -20%;
  z-index: 1;

}


.circle2 {
  background: rgba(103, 191, 198, 0.6);
  border-radius: 50%;
  width: 100%;
  height: auto;
  padding-top: 100%;
  z-index: 0;
  position: absolute;
  bottom: 3%;
  z-index: 0;
  right: -3%;

}


.score {
  font-size: 13px;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0.11em;
  text-transform: uppercase;
  color: #1E5634;
}

.score_circle {
  font-size: 72px;
  color: #FFFFFF;
  font-family: Roboto-Regular;
  text-align: center;
  font-weight: bold;
  background: #1E5634;
  opacity: 0.7;
  border-radius: 50%;
  width: 178px;
  height: 178px;
  line-height: 170px;

  border: 2px solid #FFFFFF;
  box-sizing: border-box;
}

.line {
  background-image: linear-gradient(#fff, #fff);
  background-size: 1px 100%;
  background-repeat: no-repeat;
  background-position: center center;
  height: 101px;
}

.score_group {
  text-align: center;
  width: 178px;
  z-index: 3;
  position: absolute;
  bottom: 29%;
  left: -9%;
}

.disclosure {
  font-size: 14px;
  line-height: 17px;
  color: #F1F2F2;
  background: #1E5634;
  padding-left: 11%;
  padding-top: 42px;
  padding-bottom: 42px;
  text-align: left;
  padding-right: 209px;
  font-family: Roboto-Regular;


}


.p_circle1 {
  font-size: 25px;
  color: #FFFFFF;
  font-family: Roboto-Regular;
  text-align: center;
  font-weight: bold;
  background: rgba(30, 86, 52, 0.8);
  border-radius: 50%;
  width: 92px;
  height: 92px;
  line-height: 85px;

  border: 1px solid #FFFFFF;
  box-sizing: border-box;
  margin: auto;
}

.line1 {
  background-image: linear-gradient(#fff, #fff);
  background-size: 1px 100%;
  background-repeat: no-repeat;
  background-position: center center;
  height: 38px;
}

.group1 {
  text-align: center;
  width: 221px;
  z-index: 3;
  position: absolute;
  top: 0;
  right: 8%;
}

.percentage1 {
  color: #000000;
  font-size: 0.82em;
  text-align: center;
  line-height: 1.38em;
  width: 12.3em;
  top: -76px;
  right: 8%;
  position: absolute;
}

.group2 {
  text-align: center;
  width: 221px;
  z-index: 3;
  position: absolute;
  top: -87px;
  right: 48%;
}

.percentage2 {
  color: #000000;
  font-size: 0.82em;
  text-align: center;
  line-height: 1.38em;
  width: 12.3em;
  top: -166px;
  right: 48%;
  position: absolute;
}

.group3 {
  text-align: center;
  width: 221px;
  z-index: 3;
  position: absolute;
  top: 0;
  right: 65%;
}

.percentage3 {
  color: #000000;
  font-size: 0.82em;
  text-align: center;
  line-height: 1.38em;
  width: 12.3em;
  top: -85px;
  right: 65%;
  position: absolute;
}


/*Extra small devices (portrait phones, less than 576px)*/
@media (max-width: 575.98px) {
  .caption {
    display: none;
  }


  .logo {
    width: 66px;
  }

  .title {
    margin-top: 28px;
  }


  .subcontent {
    margin-top: 10px;
  }

  .btn-primary {
    font-size: 9px;
    letter-spacing: 0.12em;
    line-height: 12px;
    border-radius: 17px;
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 17px;
    padding-right: 17px;

  }


  .quiz {
    margin-top: 19px;
    margin-bottom: 5%;
  }

  .question {
    font-size: 10px;
    line-height: 14px;
    margin-top: 20px;
    margin-bottom: 0px;
  }


  .subcontent_2 {
    margin-top: 19px;
    text-align: left;
  }

  .content_footer {
    padding-top: 44px;
    padding-left: 6%;
    padding-right: 15%;
    padding-bottom: 10px;

  }

  .image {
    position: relative;
    padding: 0;

  }

  .circle1 {
    bottom: -40px;
    left: 25%;
    padding-top: 60%;
    width: 60%;
  }

  .circle2 {
    padding-top: 65%;
    width: 65%;
    left: 38%;
  }

  .circle2 div {
    z-index: 3;
  }

  .responsive {
    width: 100%;
  }

  .score {
    font-size: 8px;
    line-height: 11px;
  }

  .score_circle {
    font-size: 20px;
    width: 57px;
    height: 57px;
    line-height: 50px;
    margin: auto;
  }

  .score_group {
    width: 118px;
    padding-bottom: 20%;
    left: 20%;

  }

  .line {
    height: 28px;

  }

  .footer_1 {
    padding: 0;
  }

  .footer_2 {
    padding-top: 10px;
    padding-left: 0;
  }

  .disclosure {
    display: none;
  }


  .percentage1 {
    font-size: 7px;
    text-align: left;
    line-height: 10px;
    width: 63%;
    padding-left: 0;
    position: absolute;
    top: 1px;
    left: -50%;
    padding-right: 36px;

  }

  .line1 {
    background-image: linear-gradient(#fff, #fff);
    background-size: 100% 1px;
    background-repeat: no-repeat;
    background-position: center center;
    width: 50%;
  }

  .p_circle1 {
    font-size: 10px;
    line-height: 31px;
    width: 36px;
    height: 36px;

    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  .group1 {
    left: -50%;
    margin-top: 4%;
    display: inline-flex;
    width: 83%;

  }

  .group2 {
    /*left: -50%;
    bottom: 0;
    display: inline-flex;
    width: 83%;
    top: 54px;*/
    display: none;
  }

  .group3 {
    /*display: none;*/
    left: -33%;
    bottom: 0;
    display: inline-flex;
    width: 90%;
    top: 9px;
  }

  .percentage3 {
    /*display: none;*/
    font-size: 7px;
    text-align: left;
    line-height: 10px;
    width: 65%;
    padding-left: 0;
    position: absolute;
    bottom: 0;
    left: -33%;
    top: -3px;
    padding-right: 36px;
  }

  .percentage2 {
    /*font-size: 7px;
      text-align: left;
      line-height: 10px;
      width: 63%;
      padding-left: 0;
      position: absolute;
      bottom: 0;
      left: -50%;
      top: 43px;
      padding-right: 36px;*/
    display: none;
  }


}

/*Small devices (landscape phones, 576px and up)*/
@media (min-width: 576px) and (max-width: 767.98px) {
  .caption {
    display: none;
  }

  .logo {
    width: 66px;
  }

  .title {
    margin-top: 28px;
  }


  .subcontent {
    margin-top: 10px;
  }

  .quiz {
    margin-top: 22px;
    margin-bottom: 25px;
  }

  .btn-primary {
    font-size: 12px;
    letter-spacing: 0.12em;
    line-height: 15px;
    border-radius: 20px;
    padding-top: 11px;
    padding-bottom: 11px;
    padding-left: 20px;
    padding-right: 20px;

  }

  .question {
    font-size: 17px;
    line-height: 21px;
    font-family: Roboto-Bold;
    margin-top: 13px;
    margin-bottom: 0px;
  }


  .subcontent_2 {
    margin-top: 19px;
    text-align: left;
  }

  .content_footer {
    padding-top: 44px;
    padding-left: 6%;
    padding-right: 15%;
    padding-bottom: 10px;
  }

  .image {
    position: relative;
    padding: 0;

  }

  .circle1 {
    bottom: -71px;
    left: 24%;
    padding-top: 65%;
    width: 65%;
  }

  .circle2 {
    padding-top: 65%;
    width: 65%;
    left: 38%;
  }

  .score {
    font-size: 12px;
    line-height: 17px;
  }

  .score_circle {
    font-size: 20px;
    width: 90px;
    height: 90px;
    line-height: 82px;
    margin: auto;
  }

  .score_group {
    width: 165px;
    padding-bottom: 20%;
    left: 21%;

  }

  .line {
    height: 28px;

  }

  .footer_1 {
    padding: 0;
  }

  .footer_2 {
    padding-top: 10px;
    padding-left: 0;
  }

  .responsive {
    width: 100%;
  }

  .disclosure {
    display: none;
  }

  .group3 {
    display: none;
  }

  .percentage3 {
    display: none;
  }

  .percentage1 {
    font-size: 7px;
    text-align: left;
    line-height: 10px;
    width: 44%;
    padding-left: 0;
    position: absolute;
    top: 10px;
    left: -55%;
    padding-right: 36px;

  }

  .line1 {
    background-image: linear-gradient(#fff, #fff);
    background-size: 100% 1px;
    background-repeat: no-repeat;
    background-position: center center;
    width: 50%;
  }

  .p_circle1 {
    font-size: 10px;
    line-height: 31px;
    width: 36px;
    height: 36px;

    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  .group1 {
    left: -55%;
    top: 4%;
    display: inline-flex;
    width: 83%;

  }

  .group2 {
    left: -55%;
    bottom: 0;
    display: inline-flex;
    width: 83%;
    top: 78px;
  }

  .group3 {
    display: none;
  }

  .percentage3 {
    display: none;
  }

  .percentage2 {
    font-size: 7px;
    text-align: left;
    line-height: 10px;
    width: 44%;
    padding-left: 0;
    position: absolute;
    bottom: 0;
    left: -55%;
    top: 70px;
    padding-right: 36px;
  }


}

/*Medium devices (tablets, 768px and up)*/
@media (min-width: 768px) and (max-width: 991.98px) {

  .logo {
    width: 120px;
  }

  .title {
    margin-top: 22px;
  }

  .subcontent {
    margin-top: 20px;
    padding-right: 20px;
  }


  .quiz {
    margin-top: 40px;
  }


  .caption {
    font-size: 8px;
    line-height: 13px;
    margin-bottom: 30px;
    padding-right: 35%;
  }

  .question {
    margin-top: 45px;
    margin-bottom: 75px;
    font-size: 19px;
    padding-right: 49px;
  }


  .subcontent_2 {
    margin-top: 19px;
    text-align: left;
  }

  .content_footer {
    padding: 30px;
  }

  .image {
    padding: 0;

  }

  /*.circle1{
    padding-top: 100%;
       width: 100%;
       left : 9%;
       bottom: -12%;
  }*/
  /*.circle2{
    padding-top: 100%;
       width: 100%;
       right:-25%;
       bottom: 0%;
  }*/
  .score {
    font-size: 10px;
    line-height: 15px;
  }

  .score_circle {
    font-size: 45px;
    width: 100px;
    height: 100px;
    line-height: 95px;
  }

  .score_group {
    width: 100px;
    bottom: 19%;
    left: -2%;
  }

  .disclosure {
    padding-left: 5%;
    padding-right: 30px;
    padding-bottom: 30px;
    padding-top: 30px;
    font-size: 12px;
    line-height: 15px;

  }

  .line1 {
    background-image: linear-gradient(#fff, #fff);
    background-size: 1px 100%;
    background-repeat: no-repeat;
    background-position: center center;
    height: 28px;
  }

  .p_circle1 {
    font-size: 13px;
    width: 50px;
    height: 50px;
    line-height: 44px;

    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    margin: auto;
  }

  .group1 {
    text-align: center;
    width: 125px;
    z-index: 3;
    position: absolute;
    top: -19px;
  }

  .percentage1 {
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -80px;
    position: absolute;
    right: 6%;
    z-index: 4;
  }

  .group2 {
    text-align: center;
    width: 125px;
    z-index: 3;
    position: absolute;
    top: -56px;
    right: 48%;
  }

  .percentage2 {
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -122px;
    right: 48%;
  }

  .group3 {
    text-align: center;
    width: 125px;
    z-index: 3;
    position: absolute;
    top: -30px;
    right: 60%;
  }

  .percentage3 {
    color: #000000;
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -95px;
    right: 60%;
    position: absolute;
  }


}

/*Large devices (desktops, 992px and up)*/
@media (min-width: 992px) and (max-width: 1199.98px) {

  .title {
    margin-top: 35px;
  }

  .caption {
    font-size: 11px;
    line-height: 16px;
    margin-bottom: 60px;
    padding-right: 38%;

  }

  .subcontent {
    margin-top: 20px;
    padding-right: 55px;
  }


  /*.circle1{
    padding-top: 100%;
       width: 100%;
       left : 0%;
       bottom: -11%;
  }*/
  /*.circle2{
    padding-top: 100%;
       width: 100%;
       right: -28%;
       bottom: 1%;
  }*/
  .btn-primary {
    font-size: 17px;
    letter-spacing: 2px;
    line-height: 20px;
    border-radius: 30px;
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 30px;
    padding-right: 30px;

  }

  .quiz {
    margin-top: 40px;
  }

  .question {
    margin-top: 55px;
    margin-bottom: 140px;
    font-size: 22px;
    padding-right: 69px;
  }

  .subcontent_2 {
    margin-top: 19px;
    text-align: left;
  }

  .footer_1 {
    padding-right: 4%;
  }

  .footer_2 {
    padding-left: 9%;
  }

  .content_footer {
    padding-left: 6%;
    padding-top: 92px;
    padding-right: 8%;
    padding-bottom: 92px;
  }


  .score {
    font-size: 11px;
    line-height: 15px;
  }

  .score_circle {
    font-size: 62px;
    width: 162px;
    height: 162px;
    line-height: 155px;
  }

  .score_group {
    width: 162px;
    bottom: 27%;
    left: -14%;
  }

  .disclosure {
    padding-left: 6%;
    padding-right: 8%;
    padding-bottom: 40px;
    padding-top: 40px;
    font-size: 13px;
    line-height: 16px;

  }


  .line1 {
    background-image: linear-gradient(#fff, #fff);
    background-size: 1px 100%;
    background-repeat: no-repeat;
    background-position: center center;
    height: 28px;
  }

  .p_circle1 {
    font-size: 13px;
    width: 50px;
    height: 50px;
    line-height: 44px;

    border: 1px solid #FFFFFF;
    box-sizing: border-box;
    margin: auto;
  }

  .group1 {
    text-align: center;
    width: 138px;
    z-index: 3;
    position: absolute;
    top: -10px;
    right: 8%;
  }

  .percentage1 {
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -80px;
    position: absolute;
    right: 8%;
    z-index: 4;
  }

  .group2 {
    text-align: center;
    width: 138px;
    z-index: 3;
    position: absolute;
    top: -56px;
    right: 48%;
  }

  .percentage2 {
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -122px;
    right: 48%;
    position: absolute;
  }


  .group3 {
    text-align: center;
    width: 138px;
    z-index: 3;
    position: absolute;
    top: 0px;
    right: 65%;
  }

  .percentage3 {
    font-size: 0.65em;
    text-align: center;
    line-height: 15px;
    width: 10.68em;
    top: -70px;
    right: 65%;
    position: absolute;
  }


}

/*Extra large devices (large desktops, 1200px and 1600px)*/
@media (min-width: 1200px) and (max-width: 1599.99px) {
  .caption {
    font-size: 13px;
    line-height: 18px;
    margin-bottom: 60px;
    padding-right: 38%;

  }

  .score {
    font-size: 12px;
    line-height: 16px;
  }

  .score_circle {
    font-size: 65px;
    width: 168px;
    height: 168px;
    line-height: 160px;
  }

  .score_group {
    width: 178px;
    bottom: 24%;
    left: -13%;
  }


  .title {
    margin-top: 85px;
    padding-right: 11%;
  }


  .quiz {
    margin-top: 40px;
  }

  .question {
    margin-top: 55px;
    margin-bottom: 100px;
    font-size: 22px;
    padding-right: 29%;
  }

  /*.circle1{

       bottom: -12%;
       left: 0;
  }*/
  /*.circle2{
    bottom: 0%;
    right: -26%;
  }*/
  .footer_1 {
    padding-right: 4%;
  }

  .footer_2 {
    padding-left: 9%;
  }

  .content_footer {
    padding-left: 8%;
    padding-top: 92px;
    padding-right: 8%;
    padding-bottom: 92px;
  }

  .disclosure {
    padding-left: 8%;
    padding-right: 8%;
    padding-bottom: 40px;
    padding-top: 40px;
    font-size: 13px;
    line-height: 16px;

  }


  .group1 {

    position: absolute;
    top: -46px;
  }

  .percentage1 {
    top: -124px;
  }


  .group3 {
    top: 0px;
    right: 65%;
  }

  .percentage3 {
    top: -77px;
    right: 65%;

  }


}

/*Extra large devices (large desktops, 1600px and up)*/
@media (min-width: 1600px) {

}

.question-title {
  font-weight: unset;
  font-size: 24px;
  line-height: 32px;
  margin-left: 17%;
  margin-right: 17%;
}

.options-container {
  font-weight: unset;
  font-size: 24px;
  line-height: 32px;
  margin-top: 4%;
  margin-left: 17%;
  margin-right: 17%;
}


.cMAHWe {
  height: 100%;
  flex: 1 1 0%;
  display: flex;
  align-items: center;
  justify-content: center;
  outline: none;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  margin-right: 6px;
  border-radius: 4px;
  background-color: rgba(0, 123, 94, 0.1);
  color: rgb(0, 123, 94);
  box-shadow: rgb(0 123 94 / 60%) 0px 0px 0px 1px inset;
  position: relative;
  transition: all 0.1s ease-out 0s;
}

.iXfLeh {
  width: 100%;
  height: 64px;
  display: flex;
}

.hYLJct {
  margin-top: 16px;
}

.gSOSRo {
  position: relative;
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  transition-duration: 0.1s;
  transition-property: background-color, color, border-color, opacity, box-shadow;
  transition-timing-function: ease-out;
  outline: none;
  border: 1px solid transparent;
  margin: 0px;
  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
  padding: 6px 14px;
  min-height: 40px;
  background-color: rgb(0, 123, 94);
  color: rgb(251, 255, 254);
  border-radius: 4px;
}

.zWQvE {
  margin-left: 8px;
}

.cXzMoW svg {
  /*display: block; */
  fill: rgb(251, 255, 254);
  transition: fill 0.2s ease 0s;
}

.bcVjSe {
  width: 100%;
  display: flex;
  flex-direction: row;
  color: rgb(0, 123, 94);
  font-size: 16px;
}

.iFdBSB {
  flex: 1 1 0%;
  text-align: center;
}

.ckBcAZ {
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 12px;
  line-height: 16px;
  color: rgb(34, 35, 35);
  font-family: sans-serif;
}

.iGvVws {
  padding-left: 80px;
  padding-right: 80px;
  text-align: left;
}

.bXMvPU {
  font-family: inherit;
  box-sizing: border-box;
  color: rgb(68, 68, 68);
  font-size: 16px;
  line-height: 24px;
}

.gJxRUj {
  display: flex;
  justify-content: flex-start;
  flex-direction: row-reverse;
  font-family: sans-serif;
  margin-top: 5%;
  margin-right: 15%;
}

.dbtMEx {
  display: flex;
  flex-direction: row-reverse;
  border-radius: 4px;
  background-color: rgb(0, 123, 94);
}

.cJsJab {
  position: relative;
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  transition-duration: 0.1s;
  transition-property: background-color, color, border-color, opacity, box-shadow;
  transition-timing-function: ease-out;
  outline: none;
  border: 1px solid transparent;
  margin: 0px;
  padding: 0px;
  width: 36px;
  min-width: 36px;
  height: 32px;
  justify-content: center;
  background-color: rgb(0, 123, 94);
  color: rgb(251, 255, 254);
  border-radius: 0px 4px 4px 0px;
}

.liPCkP {
  position: relative;
  font-family: inherit;
  font-weight: 700;
  cursor: pointer;
  transition-duration: 0.1s;
  transition-property: background-color, color, border-color, opacity, box-shadow;
  transition-timing-function: ease-out;
  outline: none;
  border: 1px solid transparent;
  margin: 0px;
  padding: 0px;
  width: 36px;
  min-width: 36px;
  height: 32px;
  justify-content: center;
  background-color: rgb(0, 123, 94);
  color: rgb(251, 255, 254);
  border-radius: 4px 0px 0px 4px;
}

.dXeGFK {
  background-color: rgba(251, 255, 254, 0.3);
  width: 1px;
}

.mxaEx svg {
  display: block;
  fill: rgb(0, 123, 94);
  transition: fill 0.2s ease 0s;
}

.dLbZJp {
  position: absolute;
  right: 100%;
}

.header_counter {
  display: inline-flex;
  align-items: center;
  color: rgb(0, 123, 94);
  font-size: 14px;
  line-height: 20px;
  /*height: 100%;*/
  outline: none;
}

.ejiAuY {
  width: 100%;
  height: 4px;
  overflow: hidden;
  background-color: rgba(0, 123, 94, 0.3);
}

.ieOzfQ {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  z-index: 30;
}

.jNBGOB {
  height: 100%;
  width: 50%;
  background-color: rgb(0, 123, 94);
  transition: all 0.4s ease 0s;
}

/* html {
  overflow-x: hidden;
  overflow-y: hidden;
}

body {
  overflow-y: hidden;
}

::ng-deep html, body {
  overflow-x: hidden;
  overflow-y: hidden;
} */

.bcgXuW {
  margin-top: 10%;
}

.cMAHWe::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  background: rgb(0, 123, 94);
  bottom: -42px;
  transition: opacity 0.1s ease-out 0s;
  opacity: 0;
}

.cMAHWe:hover {
  background: rgba(0, 123, 98, 0.4)
}

.jkvSOR {
  display: inline-table;
  margin-left: 2%;
}

.kFnuru {
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 20px;
  line-height: 28px;
}

.gnXmMk {
  display: block;
  width: 100%;
  font-family: inherit;
  color: rgb(0, 123, 94);
  padding: 0px 0px 8px;
  border: none;
  outline: none;
  border-radius: 0px;
  appearance: none;
  background-image: none;
  background-position: initial;
  background-size: initial;
  background-repeat: initial;
  background-attachment: initial;
  background-origin: initial;
  background-clip: initial;
  transform: translateZ(0px);
  font-size: 30px;
  -webkit-font-smoothing: antialiased;
  line-height: unset;
  -webkit-text-fill-color: rgb(0, 123, 94);
  animation: 1ms ease 0s 1 normal none running native-autofill-in;
  transition: background-color 1 e+08s ease 0s, box-shadow 0.1s ease-out 0s;
  box-shadow: rgb(0 123 94 / 30%) 0px 1px;
  background-color: transparent !important;
  margin-left: 3%;
}

.test {
  padding-bottom: 18%;
}


.app-countries{
  position: absolute;
  padding-right: 100px;
  left: 12%;
}

/* ::ng-deep .p-dialog{
  background: white;
} */


::ng-deep .p-dialog-mask.p-component-overlay {
  background-color: rgba(0,0,0,.85);
  z-index: 999999999 !important;
}

.dNgEQd, .kTekjC{
  min-width: 200px
}

.kTekjC{
  text-align: right;
}

.close-image{
  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
  filter: brightness(0.5);
}

.h-100{
  height: 100%;
}

.h-100vh{
  height: 100vh;
}


.active-qs{
  background: rgba(0, 123, 98, 0.4);
}

.error {
    margin: auto;
    width: 100%;
    height: 20px;
    color: #dc3545;
    font-size: 13px;
    text-align: left;
}

.congratulations{
  text-align: center;
}

.congratulations img{
  width: 300px;
}

.congratulations__text{
  font-family: Roboto-Regular;
  font-size: 30px;
  line-height: 1.3;
  margin-top: 140px;
}

.congratulations__button{
  font-family: inherit;
    font-weight: 700;
    cursor: pointer;
    outline: none;
    border: 1px solid transparent;
    margin-top: 25px;
    box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;
    padding: 15px 20px;
    min-height: 40px;
    background-color: rgb(0, 123, 94);
    color: rgb(251, 255, 254);
    border-radius: 4px;
    font-size: 25px;
}

.congratulations__press-enter{
  display: inline-table;
  margin-left: 2%;
}

.congratulations__press-enter-text{
  margin: 0px;
  max-width: 100%;
  font-weight: unset;
  font-size: 12px;
  line-height: 16px;
  color: rgb(34, 35, 35);
  font-family: sans-serif;
}


input[type="date"] {
 height: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/questionnaire/modal/modal-questionnaire.component.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,0DAA0D;AAC5D;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;;AAEtB;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,UAAU;;AAEZ;;;AAGA;EACE,wGAAwG;EACxG,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;;AAErB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;;AAGA;EACE,mCAAmC;EACnC,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;;AAEZ;;;AAGA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;;AAEZ;;;AAGA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;;EAElB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;;;AAG7B;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,iCAAiC;EACjC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;;EAEjB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;;AAGA,yDAAyD;AACzD;EACE;IACE,aAAa;EACf;;;EAGA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;;EAErB;;;EAGA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;;EAEtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;;EAEZ;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;;EAEX;;EAEA;IACE,YAAY;;EAEd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;;EAGA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,mBAAmB;;EAErB;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;;IAEZ,yBAAyB;IACzB,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;IACV,cAAc;IACd,oBAAoB;IACpB,UAAU;;EAEZ;;EAEA;IACE;;;;eAIW;IACX,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE;;;;;;;;;2BASuB;IACvB,aAAa;EACf;;;AAGF;;AAEA,iDAAiD;AACjD;EACE;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;;EAErB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,UAAU;;EAEZ;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,SAAS;;EAEX;;EAEA;IACE,YAAY;;EAEd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;;EAErB;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;IAClC,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,YAAY;;IAEZ,yBAAyB;IACzB,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,UAAU;IACV,OAAO;IACP,oBAAoB;IACpB,UAAU;;EAEZ;;EAEA;IACE,UAAU;IACV,SAAS;IACT,oBAAoB;IACpB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,SAAS;IACT,mBAAmB;EACrB;;;AAGF;;AAEA,yCAAyC;AACzC;;EAEE;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;EAClB;;;EAGA;IACE,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;;EAEZ;;EAEA;;;;;IAKE;EACF;;;;;IAKE;EACF;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;;EAEnB;;EAEA;IACE,6CAA6C;IAC7C,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;;IAEjB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,UAAU;IACV,kBAAkB;EACpB;;;AAGF;;AAEA,yCAAyC;AACzC;;EAEE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;;EAEpB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;;EAGA;;;;;IAKE;EACF;;;;;IAKE;EACF;IACE,eAAe;IACf,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;;EAErB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;;;EAGA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;;EAEnB;;;EAGA;IACE,6CAA6C;IAC7C,yBAAyB;IACzB,4BAA4B;IAC5B,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,eAAe;IACf,WAAW;IACX,YAAY;IACZ,iBAAiB;;IAEjB,yBAAyB;IACzB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,UAAU;IACV,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,UAAU;IACV,kBAAkB;EACpB;;;AAGF;;AAEA,0DAA0D;AAC1D;EACE;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;;EAEpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,UAAU;EACZ;;;EAGA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;;EAGA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;EACpB;;EAEA;;;;IAIE;EACF;;;IAGE;EACF;IACE,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;;EAEnB;;;EAGA;;IAEE,kBAAkB;IAClB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;;EAGA;IACE,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,UAAU;;EAEZ;;;AAGF;;AAEA,sDAAsD;AACtD;;AAEA;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EAEb,mBAAmB;EAEnB,uBAAuB;EACvB,aAAa;EACb,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,uCAAuC;EACvC,sBAAsB;EACtB,qDAAqD;EACrD,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+EAA+E;EAC/E,oCAAoC;EACpC,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,6CAA6C;EAC7C,iBAAiB;EACjB,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,aAAa;EAEb,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+EAA+E;EAC/E,oCAAoC;EACpC,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EAEZ,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,+EAA+E;EAC/E,oCAAoC;EACpC,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EAEZ,uBAAuB;EACvB,iCAAiC;EACjC,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,oBAAoB;EAEpB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,uCAAuC;AACzC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,aAAa;EACb,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;EAC1B,wBAAwB;EACxB,0BAA0B;EAC1B,eAAe;EACf,mCAAmC;EACnC,kBAAkB;EAClB,wCAAwC;EACxC,+DAA+D;EAC/D,yEAAyE;EACzE,uCAAuC;EACvC,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;AACX;;AAEA;;GAEG;;;AAGH;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,iCAAiC;AACnC;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;IAClB,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,6CAA6C;IAC7C,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;AACzB;;;AAGA;CACC,YAAY;AACb","sourcesContent":["@font-face {\n  font-family: Roboto-Regular;\n  src: url(/assets/fonts/Roboto-Regular/Roboto-Regular.woff);\n}\n.caption {\n  font-size: 13px;\n  line-height: 18px;\n  font-weight: 300;\n  color: #231F20;\n  font-style: italic;\n  margin-bottom: 60px;\n  padding-right: 450px;\n\n}\n\n.responsive {\n  width: 72%;\n  height: auto;\n}\n\n.image {\n\n  z-index: 2;\n  bottom: 0;\n  position: absolute;\n  right: 0;\n  text-align: right;\n  padding: 0;\n\n}\n\n\n.mainContent {\n  background: linear-gradient(47.69deg, rgba(103, 191, 198, 0.45) 16.16%, rgba(142, 198, 64, 0.45) 83.81%);\n  width: 100%;\n  height: 100%;\n}\n\n.mainContent_2 {\n  z-index: 9999;\n  background: #F1F2F2;\n\n}\n\n.footer_1 {\n  padding-right: 6%;\n}\n\n.footer_2 {\n  padding-left: 9%;\n}\n\n.title {\n  margin-top: 116px;\n}\n\n\n.subcontent {\n  margin-top: 51px;\n  padding-right: 25%;\n}\n\n.subcontent_2 {\n  margin-top: 27px;\n  text-align: left;\n}\n\n.quiz {\n  margin-top: 69px;\n\n}\n\n.contentQuiz {\n  z-index: 5;\n}\n\n.content_footer {\n  padding-left: 210px;\n  padding-top: 92px;\n  padding-right: 296px;\n  padding-bottom: 92px;\n}\n\n.question {\n  margin-top: 55px;\n  margin-bottom: 147px;\n  color: #1E5634;\n  font-size: 25px;\n  line-height: 137.19%;\n  font-family: Roboto-Bold;\n  padding-right: 31%;\n}\n\n\n.circle1 {\n  background: rgba(142, 198, 64, 0.6);\n  height: auto;\n  padding-top: 100%;\n  width: 100%;\n  border-radius: 50%;\n  position: absolute;\n  bottom: -12%;\n  left: -20%;\n  z-index: 1;\n\n}\n\n\n.circle2 {\n  background: rgba(103, 191, 198, 0.6);\n  border-radius: 50%;\n  width: 100%;\n  height: auto;\n  padding-top: 100%;\n  z-index: 0;\n  position: absolute;\n  bottom: 3%;\n  z-index: 0;\n  right: -3%;\n\n}\n\n\n.score {\n  font-size: 13px;\n  line-height: 18px;\n  text-align: center;\n  letter-spacing: 0.11em;\n  text-transform: uppercase;\n  color: #1E5634;\n}\n\n.score_circle {\n  font-size: 72px;\n  color: #FFFFFF;\n  font-family: Roboto-Regular;\n  text-align: center;\n  font-weight: bold;\n  background: #1E5634;\n  opacity: 0.7;\n  border-radius: 50%;\n  width: 178px;\n  height: 178px;\n  line-height: 170px;\n\n  border: 2px solid #FFFFFF;\n  box-sizing: border-box;\n}\n\n.line {\n  background-image: linear-gradient(#fff, #fff);\n  background-size: 1px 100%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  height: 101px;\n}\n\n.score_group {\n  text-align: center;\n  width: 178px;\n  z-index: 3;\n  position: absolute;\n  bottom: 29%;\n  left: -9%;\n}\n\n.disclosure {\n  font-size: 14px;\n  line-height: 17px;\n  color: #F1F2F2;\n  background: #1E5634;\n  padding-left: 11%;\n  padding-top: 42px;\n  padding-bottom: 42px;\n  text-align: left;\n  padding-right: 209px;\n  font-family: Roboto-Regular;\n\n\n}\n\n\n.p_circle1 {\n  font-size: 25px;\n  color: #FFFFFF;\n  font-family: Roboto-Regular;\n  text-align: center;\n  font-weight: bold;\n  background: rgba(30, 86, 52, 0.8);\n  border-radius: 50%;\n  width: 92px;\n  height: 92px;\n  line-height: 85px;\n\n  border: 1px solid #FFFFFF;\n  box-sizing: border-box;\n  margin: auto;\n}\n\n.line1 {\n  background-image: linear-gradient(#fff, #fff);\n  background-size: 1px 100%;\n  background-repeat: no-repeat;\n  background-position: center center;\n  height: 38px;\n}\n\n.group1 {\n  text-align: center;\n  width: 221px;\n  z-index: 3;\n  position: absolute;\n  top: 0;\n  right: 8%;\n}\n\n.percentage1 {\n  color: #000000;\n  font-size: 0.82em;\n  text-align: center;\n  line-height: 1.38em;\n  width: 12.3em;\n  top: -76px;\n  right: 8%;\n  position: absolute;\n}\n\n.group2 {\n  text-align: center;\n  width: 221px;\n  z-index: 3;\n  position: absolute;\n  top: -87px;\n  right: 48%;\n}\n\n.percentage2 {\n  color: #000000;\n  font-size: 0.82em;\n  text-align: center;\n  line-height: 1.38em;\n  width: 12.3em;\n  top: -166px;\n  right: 48%;\n  position: absolute;\n}\n\n.group3 {\n  text-align: center;\n  width: 221px;\n  z-index: 3;\n  position: absolute;\n  top: 0;\n  right: 65%;\n}\n\n.percentage3 {\n  color: #000000;\n  font-size: 0.82em;\n  text-align: center;\n  line-height: 1.38em;\n  width: 12.3em;\n  top: -85px;\n  right: 65%;\n  position: absolute;\n}\n\n\n/*Extra small devices (portrait phones, less than 576px)*/\n@media (max-width: 575.98px) {\n  .caption {\n    display: none;\n  }\n\n\n  .logo {\n    width: 66px;\n  }\n\n  .title {\n    margin-top: 28px;\n  }\n\n\n  .subcontent {\n    margin-top: 10px;\n  }\n\n  .btn-primary {\n    font-size: 9px;\n    letter-spacing: 0.12em;\n    line-height: 12px;\n    border-radius: 17px;\n    padding-top: 8px;\n    padding-bottom: 8px;\n    padding-left: 17px;\n    padding-right: 17px;\n\n  }\n\n\n  .quiz {\n    margin-top: 19px;\n    margin-bottom: 5%;\n  }\n\n  .question {\n    font-size: 10px;\n    line-height: 14px;\n    margin-top: 20px;\n    margin-bottom: 0px;\n  }\n\n\n  .subcontent_2 {\n    margin-top: 19px;\n    text-align: left;\n  }\n\n  .content_footer {\n    padding-top: 44px;\n    padding-left: 6%;\n    padding-right: 15%;\n    padding-bottom: 10px;\n\n  }\n\n  .image {\n    position: relative;\n    padding: 0;\n\n  }\n\n  .circle1 {\n    bottom: -40px;\n    left: 25%;\n    padding-top: 60%;\n    width: 60%;\n  }\n\n  .circle2 {\n    padding-top: 65%;\n    width: 65%;\n    left: 38%;\n  }\n\n  .circle2 div {\n    z-index: 3;\n  }\n\n  .responsive {\n    width: 100%;\n  }\n\n  .score {\n    font-size: 8px;\n    line-height: 11px;\n  }\n\n  .score_circle {\n    font-size: 20px;\n    width: 57px;\n    height: 57px;\n    line-height: 50px;\n    margin: auto;\n  }\n\n  .score_group {\n    width: 118px;\n    padding-bottom: 20%;\n    left: 20%;\n\n  }\n\n  .line {\n    height: 28px;\n\n  }\n\n  .footer_1 {\n    padding: 0;\n  }\n\n  .footer_2 {\n    padding-top: 10px;\n    padding-left: 0;\n  }\n\n  .disclosure {\n    display: none;\n  }\n\n\n  .percentage1 {\n    font-size: 7px;\n    text-align: left;\n    line-height: 10px;\n    width: 63%;\n    padding-left: 0;\n    position: absolute;\n    top: 1px;\n    left: -50%;\n    padding-right: 36px;\n\n  }\n\n  .line1 {\n    background-image: linear-gradient(#fff, #fff);\n    background-size: 100% 1px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    width: 50%;\n  }\n\n  .p_circle1 {\n    font-size: 10px;\n    line-height: 31px;\n    width: 36px;\n    height: 36px;\n\n    border: 1px solid #FFFFFF;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n\n  .group1 {\n    left: -50%;\n    margin-top: 4%;\n    display: inline-flex;\n    width: 83%;\n\n  }\n\n  .group2 {\n    /*left: -50%;\n    bottom: 0;\n    display: inline-flex;\n    width: 83%;\n    top: 54px;*/\n    display: none;\n  }\n\n  .group3 {\n    /*display: none;*/\n    left: -33%;\n    bottom: 0;\n    display: inline-flex;\n    width: 90%;\n    top: 9px;\n  }\n\n  .percentage3 {\n    /*display: none;*/\n    font-size: 7px;\n    text-align: left;\n    line-height: 10px;\n    width: 65%;\n    padding-left: 0;\n    position: absolute;\n    bottom: 0;\n    left: -33%;\n    top: -3px;\n    padding-right: 36px;\n  }\n\n  .percentage2 {\n    /*font-size: 7px;\n      text-align: left;\n      line-height: 10px;\n      width: 63%;\n      padding-left: 0;\n      position: absolute;\n      bottom: 0;\n      left: -50%;\n      top: 43px;\n      padding-right: 36px;*/\n    display: none;\n  }\n\n\n}\n\n/*Small devices (landscape phones, 576px and up)*/\n@media (min-width: 576px) and (max-width: 767.98px) {\n  .caption {\n    display: none;\n  }\n\n  .logo {\n    width: 66px;\n  }\n\n  .title {\n    margin-top: 28px;\n  }\n\n\n  .subcontent {\n    margin-top: 10px;\n  }\n\n  .quiz {\n    margin-top: 22px;\n    margin-bottom: 25px;\n  }\n\n  .btn-primary {\n    font-size: 12px;\n    letter-spacing: 0.12em;\n    line-height: 15px;\n    border-radius: 20px;\n    padding-top: 11px;\n    padding-bottom: 11px;\n    padding-left: 20px;\n    padding-right: 20px;\n\n  }\n\n  .question {\n    font-size: 17px;\n    line-height: 21px;\n    font-family: Roboto-Bold;\n    margin-top: 13px;\n    margin-bottom: 0px;\n  }\n\n\n  .subcontent_2 {\n    margin-top: 19px;\n    text-align: left;\n  }\n\n  .content_footer {\n    padding-top: 44px;\n    padding-left: 6%;\n    padding-right: 15%;\n    padding-bottom: 10px;\n  }\n\n  .image {\n    position: relative;\n    padding: 0;\n\n  }\n\n  .circle1 {\n    bottom: -71px;\n    left: 24%;\n    padding-top: 65%;\n    width: 65%;\n  }\n\n  .circle2 {\n    padding-top: 65%;\n    width: 65%;\n    left: 38%;\n  }\n\n  .score {\n    font-size: 12px;\n    line-height: 17px;\n  }\n\n  .score_circle {\n    font-size: 20px;\n    width: 90px;\n    height: 90px;\n    line-height: 82px;\n    margin: auto;\n  }\n\n  .score_group {\n    width: 165px;\n    padding-bottom: 20%;\n    left: 21%;\n\n  }\n\n  .line {\n    height: 28px;\n\n  }\n\n  .footer_1 {\n    padding: 0;\n  }\n\n  .footer_2 {\n    padding-top: 10px;\n    padding-left: 0;\n  }\n\n  .responsive {\n    width: 100%;\n  }\n\n  .disclosure {\n    display: none;\n  }\n\n  .group3 {\n    display: none;\n  }\n\n  .percentage3 {\n    display: none;\n  }\n\n  .percentage1 {\n    font-size: 7px;\n    text-align: left;\n    line-height: 10px;\n    width: 44%;\n    padding-left: 0;\n    position: absolute;\n    top: 10px;\n    left: -55%;\n    padding-right: 36px;\n\n  }\n\n  .line1 {\n    background-image: linear-gradient(#fff, #fff);\n    background-size: 100% 1px;\n    background-repeat: no-repeat;\n    background-position: center center;\n    width: 50%;\n  }\n\n  .p_circle1 {\n    font-size: 10px;\n    line-height: 31px;\n    width: 36px;\n    height: 36px;\n\n    border: 1px solid #FFFFFF;\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n\n  .group1 {\n    left: -55%;\n    top: 4%;\n    display: inline-flex;\n    width: 83%;\n\n  }\n\n  .group2 {\n    left: -55%;\n    bottom: 0;\n    display: inline-flex;\n    width: 83%;\n    top: 78px;\n  }\n\n  .group3 {\n    display: none;\n  }\n\n  .percentage3 {\n    display: none;\n  }\n\n  .percentage2 {\n    font-size: 7px;\n    text-align: left;\n    line-height: 10px;\n    width: 44%;\n    padding-left: 0;\n    position: absolute;\n    bottom: 0;\n    left: -55%;\n    top: 70px;\n    padding-right: 36px;\n  }\n\n\n}\n\n/*Medium devices (tablets, 768px and up)*/\n@media (min-width: 768px) and (max-width: 991.98px) {\n\n  .logo {\n    width: 120px;\n  }\n\n  .title {\n    margin-top: 22px;\n  }\n\n  .subcontent {\n    margin-top: 20px;\n    padding-right: 20px;\n  }\n\n\n  .quiz {\n    margin-top: 40px;\n  }\n\n\n  .caption {\n    font-size: 8px;\n    line-height: 13px;\n    margin-bottom: 30px;\n    padding-right: 35%;\n  }\n\n  .question {\n    margin-top: 45px;\n    margin-bottom: 75px;\n    font-size: 19px;\n    padding-right: 49px;\n  }\n\n\n  .subcontent_2 {\n    margin-top: 19px;\n    text-align: left;\n  }\n\n  .content_footer {\n    padding: 30px;\n  }\n\n  .image {\n    padding: 0;\n\n  }\n\n  /*.circle1{\n    padding-top: 100%;\n       width: 100%;\n       left : 9%;\n       bottom: -12%;\n  }*/\n  /*.circle2{\n    padding-top: 100%;\n       width: 100%;\n       right:-25%;\n       bottom: 0%;\n  }*/\n  .score {\n    font-size: 10px;\n    line-height: 15px;\n  }\n\n  .score_circle {\n    font-size: 45px;\n    width: 100px;\n    height: 100px;\n    line-height: 95px;\n  }\n\n  .score_group {\n    width: 100px;\n    bottom: 19%;\n    left: -2%;\n  }\n\n  .disclosure {\n    padding-left: 5%;\n    padding-right: 30px;\n    padding-bottom: 30px;\n    padding-top: 30px;\n    font-size: 12px;\n    line-height: 15px;\n\n  }\n\n  .line1 {\n    background-image: linear-gradient(#fff, #fff);\n    background-size: 1px 100%;\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 28px;\n  }\n\n  .p_circle1 {\n    font-size: 13px;\n    width: 50px;\n    height: 50px;\n    line-height: 44px;\n\n    border: 1px solid #FFFFFF;\n    box-sizing: border-box;\n    margin: auto;\n  }\n\n  .group1 {\n    text-align: center;\n    width: 125px;\n    z-index: 3;\n    position: absolute;\n    top: -19px;\n  }\n\n  .percentage1 {\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -80px;\n    position: absolute;\n    right: 6%;\n    z-index: 4;\n  }\n\n  .group2 {\n    text-align: center;\n    width: 125px;\n    z-index: 3;\n    position: absolute;\n    top: -56px;\n    right: 48%;\n  }\n\n  .percentage2 {\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -122px;\n    right: 48%;\n  }\n\n  .group3 {\n    text-align: center;\n    width: 125px;\n    z-index: 3;\n    position: absolute;\n    top: -30px;\n    right: 60%;\n  }\n\n  .percentage3 {\n    color: #000000;\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -95px;\n    right: 60%;\n    position: absolute;\n  }\n\n\n}\n\n/*Large devices (desktops, 992px and up)*/\n@media (min-width: 992px) and (max-width: 1199.98px) {\n\n  .title {\n    margin-top: 35px;\n  }\n\n  .caption {\n    font-size: 11px;\n    line-height: 16px;\n    margin-bottom: 60px;\n    padding-right: 38%;\n\n  }\n\n  .subcontent {\n    margin-top: 20px;\n    padding-right: 55px;\n  }\n\n\n  /*.circle1{\n    padding-top: 100%;\n       width: 100%;\n       left : 0%;\n       bottom: -11%;\n  }*/\n  /*.circle2{\n    padding-top: 100%;\n       width: 100%;\n       right: -28%;\n       bottom: 1%;\n  }*/\n  .btn-primary {\n    font-size: 17px;\n    letter-spacing: 2px;\n    line-height: 20px;\n    border-radius: 30px;\n    padding-top: 15px;\n    padding-bottom: 15px;\n    padding-left: 30px;\n    padding-right: 30px;\n\n  }\n\n  .quiz {\n    margin-top: 40px;\n  }\n\n  .question {\n    margin-top: 55px;\n    margin-bottom: 140px;\n    font-size: 22px;\n    padding-right: 69px;\n  }\n\n  .subcontent_2 {\n    margin-top: 19px;\n    text-align: left;\n  }\n\n  .footer_1 {\n    padding-right: 4%;\n  }\n\n  .footer_2 {\n    padding-left: 9%;\n  }\n\n  .content_footer {\n    padding-left: 6%;\n    padding-top: 92px;\n    padding-right: 8%;\n    padding-bottom: 92px;\n  }\n\n\n  .score {\n    font-size: 11px;\n    line-height: 15px;\n  }\n\n  .score_circle {\n    font-size: 62px;\n    width: 162px;\n    height: 162px;\n    line-height: 155px;\n  }\n\n  .score_group {\n    width: 162px;\n    bottom: 27%;\n    left: -14%;\n  }\n\n  .disclosure {\n    padding-left: 6%;\n    padding-right: 8%;\n    padding-bottom: 40px;\n    padding-top: 40px;\n    font-size: 13px;\n    line-height: 16px;\n\n  }\n\n\n  .line1 {\n    background-image: linear-gradient(#fff, #fff);\n    background-size: 1px 100%;\n    background-repeat: no-repeat;\n    background-position: center center;\n    height: 28px;\n  }\n\n  .p_circle1 {\n    font-size: 13px;\n    width: 50px;\n    height: 50px;\n    line-height: 44px;\n\n    border: 1px solid #FFFFFF;\n    box-sizing: border-box;\n    margin: auto;\n  }\n\n  .group1 {\n    text-align: center;\n    width: 138px;\n    z-index: 3;\n    position: absolute;\n    top: -10px;\n    right: 8%;\n  }\n\n  .percentage1 {\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -80px;\n    position: absolute;\n    right: 8%;\n    z-index: 4;\n  }\n\n  .group2 {\n    text-align: center;\n    width: 138px;\n    z-index: 3;\n    position: absolute;\n    top: -56px;\n    right: 48%;\n  }\n\n  .percentage2 {\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -122px;\n    right: 48%;\n    position: absolute;\n  }\n\n\n  .group3 {\n    text-align: center;\n    width: 138px;\n    z-index: 3;\n    position: absolute;\n    top: 0px;\n    right: 65%;\n  }\n\n  .percentage3 {\n    font-size: 0.65em;\n    text-align: center;\n    line-height: 15px;\n    width: 10.68em;\n    top: -70px;\n    right: 65%;\n    position: absolute;\n  }\n\n\n}\n\n/*Extra large devices (large desktops, 1200px and 1600px)*/\n@media (min-width: 1200px) and (max-width: 1599.99px) {\n  .caption {\n    font-size: 13px;\n    line-height: 18px;\n    margin-bottom: 60px;\n    padding-right: 38%;\n\n  }\n\n  .score {\n    font-size: 12px;\n    line-height: 16px;\n  }\n\n  .score_circle {\n    font-size: 65px;\n    width: 168px;\n    height: 168px;\n    line-height: 160px;\n  }\n\n  .score_group {\n    width: 178px;\n    bottom: 24%;\n    left: -13%;\n  }\n\n\n  .title {\n    margin-top: 85px;\n    padding-right: 11%;\n  }\n\n\n  .quiz {\n    margin-top: 40px;\n  }\n\n  .question {\n    margin-top: 55px;\n    margin-bottom: 100px;\n    font-size: 22px;\n    padding-right: 29%;\n  }\n\n  /*.circle1{\n\n       bottom: -12%;\n       left: 0;\n  }*/\n  /*.circle2{\n    bottom: 0%;\n    right: -26%;\n  }*/\n  .footer_1 {\n    padding-right: 4%;\n  }\n\n  .footer_2 {\n    padding-left: 9%;\n  }\n\n  .content_footer {\n    padding-left: 8%;\n    padding-top: 92px;\n    padding-right: 8%;\n    padding-bottom: 92px;\n  }\n\n  .disclosure {\n    padding-left: 8%;\n    padding-right: 8%;\n    padding-bottom: 40px;\n    padding-top: 40px;\n    font-size: 13px;\n    line-height: 16px;\n\n  }\n\n\n  .group1 {\n\n    position: absolute;\n    top: -46px;\n  }\n\n  .percentage1 {\n    top: -124px;\n  }\n\n\n  .group3 {\n    top: 0px;\n    right: 65%;\n  }\n\n  .percentage3 {\n    top: -77px;\n    right: 65%;\n\n  }\n\n\n}\n\n/*Extra large devices (large desktops, 1600px and up)*/\n@media (min-width: 1600px) {\n\n}\n\n.question-title {\n  font-weight: unset;\n  font-size: 24px;\n  line-height: 32px;\n  margin-left: 17%;\n  margin-right: 17%;\n}\n\n.options-container {\n  font-weight: unset;\n  font-size: 24px;\n  line-height: 32px;\n  margin-top: 4%;\n  margin-left: 17%;\n  margin-right: 17%;\n}\n\n\n.cMAHWe {\n  height: 100%;\n  flex: 1 1 0%;\n  display: flex;\n  -webkit-box-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  justify-content: center;\n  outline: none;\n  cursor: pointer;\n  user-select: none;\n  margin-right: 6px;\n  border-radius: 4px;\n  background-color: rgba(0, 123, 94, 0.1);\n  color: rgb(0, 123, 94);\n  box-shadow: rgb(0 123 94 / 60%) 0px 0px 0px 1px inset;\n  position: relative;\n  transition: all 0.1s ease-out 0s;\n}\n\n.iXfLeh {\n  width: 100%;\n  height: 64px;\n  display: flex;\n}\n\n.hYLJct {\n  margin-top: 16px;\n}\n\n.gSOSRo {\n  position: relative;\n  font-family: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  transition-duration: 0.1s;\n  transition-property: background-color, color, border-color, opacity, box-shadow;\n  transition-timing-function: ease-out;\n  outline: none;\n  border: 1px solid transparent;\n  margin: 0px;\n  box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;\n  padding: 6px 14px;\n  min-height: 40px;\n  background-color: rgb(0, 123, 94);\n  color: rgb(251, 255, 254);\n  border-radius: 4px;\n}\n\n.zWQvE {\n  margin-left: 8px;\n}\n\n.cXzMoW svg {\n  /*display: block; */\n  fill: rgb(251, 255, 254);\n  transition: fill 0.2s ease 0s;\n}\n\n.bcVjSe {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  color: rgb(0, 123, 94);\n  font-size: 16px;\n}\n\n.iFdBSB {\n  flex: 1 1 0%;\n  text-align: center;\n}\n\n.ckBcAZ {\n  margin: 0px;\n  max-width: 100%;\n  font-weight: unset;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgb(34, 35, 35);\n  font-family: sans-serif;\n}\n\n.iGvVws {\n  padding-left: 80px;\n  padding-right: 80px;\n  text-align: left;\n}\n\n.bXMvPU {\n  font-family: inherit;\n  box-sizing: border-box;\n  color: rgb(68, 68, 68);\n  font-size: 16px;\n  line-height: 24px;\n}\n\n.gJxRUj {\n  display: flex;\n  -webkit-box-pack: start;\n  justify-content: flex-start;\n  flex-direction: row-reverse;\n  font-family: sans-serif;\n  margin-top: 5%;\n  margin-right: 15%;\n}\n\n.dbtMEx {\n  display: flex;\n  flex-direction: row-reverse;\n  border-radius: 4px;\n  background-color: rgb(0, 123, 94);\n}\n\n.cJsJab {\n  position: relative;\n  font-family: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  transition-duration: 0.1s;\n  transition-property: background-color, color, border-color, opacity, box-shadow;\n  transition-timing-function: ease-out;\n  outline: none;\n  border: 1px solid transparent;\n  margin: 0px;\n  padding: 0px;\n  width: 36px;\n  min-width: 36px;\n  height: 32px;\n  -webkit-box-pack: center;\n  justify-content: center;\n  background-color: rgb(0, 123, 94);\n  color: rgb(251, 255, 254);\n  border-radius: 0px 4px 4px 0px;\n}\n\n.liPCkP {\n  position: relative;\n  font-family: inherit;\n  font-weight: 700;\n  cursor: pointer;\n  transition-duration: 0.1s;\n  transition-property: background-color, color, border-color, opacity, box-shadow;\n  transition-timing-function: ease-out;\n  outline: none;\n  border: 1px solid transparent;\n  margin: 0px;\n  padding: 0px;\n  width: 36px;\n  min-width: 36px;\n  height: 32px;\n  -webkit-box-pack: center;\n  justify-content: center;\n  background-color: rgb(0, 123, 94);\n  color: rgb(251, 255, 254);\n  border-radius: 4px 0px 0px 4px;\n}\n\n.dXeGFK {\n  background-color: rgba(251, 255, 254, 0.3);\n  width: 1px;\n}\n\n.mxaEx svg {\n  display: block;\n  fill: rgb(0, 123, 94);\n  transition: fill 0.2s ease 0s;\n}\n\n.dLbZJp {\n  position: absolute;\n  right: 100%;\n}\n\n.header_counter {\n  display: inline-flex;\n  -webkit-box-align: center;\n  align-items: center;\n  color: rgb(0, 123, 94);\n  font-size: 14px;\n  line-height: 20px;\n  /*height: 100%;*/\n  outline: none;\n}\n\n.ejiAuY {\n  width: 100%;\n  height: 4px;\n  overflow: hidden;\n  background-color: rgba(0, 123, 94, 0.3);\n}\n\n.ieOzfQ {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  right: 0px;\n  z-index: 30;\n}\n\n.jNBGOB {\n  height: 100%;\n  width: 50%;\n  background-color: rgb(0, 123, 94);\n  transition: all 0.4s ease 0s;\n}\n\n/* html {\n  overflow-x: hidden;\n  overflow-y: hidden;\n}\n\nbody {\n  overflow-y: hidden;\n}\n\n::ng-deep html, body {\n  overflow-x: hidden;\n  overflow-y: hidden;\n} */\n\n.bcgXuW {\n  margin-top: 10%;\n}\n\n.cMAHWe::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 2px;\n  background: rgb(0, 123, 94);\n  bottom: -42px;\n  transition: opacity 0.1s ease-out 0s;\n  opacity: 0;\n}\n\n.cMAHWe:hover {\n  background: rgba(0, 123, 98, 0.4)\n}\n\n.jkvSOR {\n  display: inline-table;\n  margin-left: 2%;\n}\n\n.kFnuru {\n  margin: 0px;\n  max-width: 100%;\n  font-weight: unset;\n  font-size: 20px;\n  line-height: 28px;\n}\n\n.gnXmMk {\n  display: block;\n  width: 100%;\n  font-family: inherit;\n  color: rgb(0, 123, 94);\n  padding: 0px 0px 8px;\n  border: none;\n  outline: none;\n  border-radius: 0px;\n  appearance: none;\n  background-image: none;\n  background-position: initial;\n  background-size: initial;\n  background-repeat: initial;\n  background-attachment: initial;\n  background-origin: initial;\n  background-clip: initial;\n  transform: translateZ(0px);\n  font-size: 30px;\n  -webkit-font-smoothing: antialiased;\n  line-height: unset;\n  -webkit-text-fill-color: rgb(0, 123, 94);\n  animation: 1ms ease 0s 1 normal none running native-autofill-in;\n  transition: background-color 1 e+08s ease 0s, box-shadow 0.1s ease-out 0s;\n  box-shadow: rgb(0 123 94 / 30%) 0px 1px;\n  background-color: transparent !important;\n  margin-left: 3%;\n}\n\n.test {\n  padding-bottom: 18%;\n}\n\n\n.app-countries{\n  position: absolute;\n  padding-right: 100px;\n  left: 12%;\n}\n\n/* ::ng-deep .p-dialog{\n  background: white;\n} */\n\n\n::ng-deep .p-dialog-mask.p-component-overlay {\n  background-color: rgba(0,0,0,.85);\n  z-index: 999999999 !important;\n}\n\n.dNgEQd, .kTekjC{\n  min-width: 200px\n}\n\n.kTekjC{\n  text-align: right;\n}\n\n.close-image{\n  position: absolute;\n  right: 20px;\n  top: 20px;\n  cursor: pointer;\n  filter: brightness(0.5);\n}\n\n.h-100{\n  height: 100%;\n}\n\n.h-100vh{\n  height: 100vh;\n}\n\n\n.active-qs{\n  background: rgba(0, 123, 98, 0.4);\n}\n\n.error {\n    margin: auto;\n    width: 100%;\n    height: 20px;\n    color: #dc3545;\n    font-size: 13px;\n    text-align: left;\n}\n\n.congratulations{\n  text-align: center;\n}\n\n.congratulations img{\n  width: 300px;\n}\n\n.congratulations__text{\n  font-family: Roboto-Regular;\n  font-size: 30px;\n  line-height: 1.3;\n  margin-top: 140px;\n}\n\n.congratulations__button{\n  font-family: inherit;\n    font-weight: 700;\n    cursor: pointer;\n    outline: none;\n    border: 1px solid transparent;\n    margin-top: 25px;\n    box-shadow: rgb(0 0 0 / 10%) 0px 3px 12px 0px;\n    padding: 15px 20px;\n    min-height: 40px;\n    background-color: rgb(0, 123, 94);\n    color: rgb(251, 255, 254);\n    border-radius: 4px;\n    font-size: 25px;\n}\n\n.congratulations__press-enter{\n  display: inline-table;\n  margin-left: 2%;\n}\n\n.congratulations__press-enter-text{\n  margin: 0px;\n  max-width: 100%;\n  font-weight: unset;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgb(34, 35, 35);\n  font-family: sans-serif;\n}\n\n\ninput[type=\"date\"] {\n height: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
